import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3 13.65C3 16.603 5.418 19 8.4 19h8.1c2.485 0 4.5-2.016 4.5-4.503 0-1.847-1.11-3.552-2.7-4.247C18.132 7.323 15.684 5 12.69 5 10.35 5 8.346 6.486 7.5 8.5 4.8 8.938 3 11.2 3 13.65" }, null, -1)
  ])))
}
export default { render: render }